import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromMembership from './membership.reducer';

export const selectMembershipState = createFeatureSelector<fromMembership.MembershipState>(
  fromMembership.membershipFeatureKey,
);

export const selectMembershipLevels = createSelector(selectMembershipState, s => s.levels);

export const selectMembershipLevelsLoading = createSelector(selectMembershipState, s => s.levelsLoading);
